<template>
  <div class="hotelux-header">
    <div class="hotelux-header-inner">
      <div class="header-left">
        <responsive-logo
          v-if="showLogo"
          :src="currentLogo"
          :horizontal="{
            container: { width: '104px', height: '36px' },
            image: { maxWidth: '104px', maxHeight: '36px' }
          }"
          position="top-left"
          @click="handleLogoClick"
        />
      </div>

      <div class="header-center">
        <slot name="center" />
      </div>

      <div class="header-right">
        <currency-selector
          v-if="showCurrency"
          v-model="currency"
          @change="handleCurrencyChange"
        />

        <current-user
          :is-sticky="isSticky"
          @member="handleMemberClick"
          :settings="headerSettings"
        />

        <member-drawer :settings="headerSettings" v-model:show="memberDrawer" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { headerSettings } from "@consumerY/config/index";
import ResponsiveLogo from "@ui/ResponsiveLogo/index.vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

import { useChannelStoreHook } from "@/store/modules/channel";
import { useUserStoreHook } from "@/store/modules/user";

import CurrencySelector from "../CurrencySelector/index.vue";
import CurrentUser from "../CurrentUser/index.vue";
import MemberDrawer from "../MemberDrawer/index.vue";

const props = defineProps({
  logoUrl: {
    type: String,
    default: ""
  },
  showLogo: {
    type: Boolean,
    default: true
  },
  showCurrency: {
    type: Boolean,
    default: true
  },
  isSticky: {
    type: Boolean,
    default: false
  }
});

const router = useRouter();
const memberDrawer = ref(false);
const { channel } = useChannelStoreHook();
const userStore = useUserStoreHook();
const { currency } = storeToRefs(userStore);

const currentLogo = computed(() => {
  if (props.isSticky) {
    return "https://qiniu-uploads-cdn.charmdeer.com/hotelux_logo.png";
  }
  return props.logoUrl || channel?.logoDetail?.rectangle;
});

const handleCurrencyChange = async newCurrency => {
  await userStore.changeCurrency(newCurrency);
};

const handleMemberClick = () => {
  memberDrawer.value = true;
};

const handleLogoClick = () => {
  router.push({
    path: "/",
    query: { channel: channel.key }
  });
};

defineOptions({
  name: "HoteluxHeader"
});
</script>

<style lang="scss" scoped>
.hotelux-header {
  position: relative;
  width: 100%;
  z-index: 10;
}

.hotelux-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1520px;
  margin: 0 auto;
  // padding: 0 max(60px, calc((100% - 1520px) / 2));
}

.header-left {
  display: flex;
  align-items: center;

  :deep(.responsive-logo) {
    cursor: pointer;
  }
}

.header-center {
  display: flex;
  align-items: center;
  flex: 1;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}
</style>
